import { useState, useEffect } from 'react';
import "./FileImage.css";

interface ImageDisplayProps {
  imageURL: (string | File),
  /** The shape of the image to use. Can be square, circle, or an empty string */
  imageVariant?: string
}

export const ImageBox = ({ imageURL, imageVariant }: ImageDisplayProps) => {
  const [imageURI, setImageURI] = useState<string | File>(imageURL);


  useEffect(() => {
    if (imageURL instanceof File) {
      setImageURI(URL.createObjectURL(imageURL));
      return
    }

    if (imageURL.length > 0 && imageURL[0] != '/')
      setImageURI('/' + imageURL || "/holder.js/171x180");
    else
      setImageURI(imageURL);

  }, [imageURL]);


  return (
    <div className={`file-image ${imageVariant || ""}`}>
      <img src={imageURI as string} />
    </div>
  )
}